import React, { PropTypes } from 'react'
import css from './style.scss'
import { SearchIcon } from 'icons'
import { InputWrapper } from 'form/InputWrapper'
import Combobox from 'form/Combobox/Combobox'

const SearchSelect = (props) => {
  const { meta, hideMeta, afterControl, id } = props
  const errorId = id && !hideMeta ? `${id}-error` : undefined
  const hasError = meta.error && !meta.active && (meta.dirty || meta.touched)

  return (
    <div className={css.wrapper}>
      <InputWrapper hideMeta={hideMeta} {...meta} errorId={errorId}>
        <Combobox
          id={id}
          aria-label={props['aria-label'] || (id ? undefined : props.placeholder)}
          aria-describedby={errorId}
          aria-invalid={hasError || undefined}
          icon={<SearchIcon className={css.searchIcon} aria-hidden='true' />}
          value={props.value}
          options={props.options}
          onChange={props.onChange}
          onInputChange={props.onInputChange}
          onBlur={props.onBlur}
          placeholder={props.placeholder}
          disabled={props.disabled}
          isLoading={props.isLoading}
        />
        {afterControl}
      </InputWrapper>
    </div>
  )
}

export default SearchSelect

SearchSelect.propTypes = {
  // * redux-form meta object
  meta: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string
  }),
  // * Associates a <Label htmlFor={id}>; without it the placeholder names the field
  id: PropTypes.string,
  'aria-label': PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  /* Extra content rendered inside InputWrapper, above the reserved error text area */
  afterControl: PropTypes.node
}

SearchSelect.defaultProps = {
  meta: {}
}
